import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type VehicleAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatVehicleToastLabel(registration: string | undefined): string {
    const t = typeof registration === "string" ? registration.trim() : "";
    return t.length > 0 ? t : EntityLabels.vehicle;
}

export function getVehicleAdminActionSuccessMessage(
    kind: VehicleAdminConfirmKind,
    registration: string | undefined
): string {
    const label = formatVehicleToastLabel(registration);
    const successByKind: Record<VehicleAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type VehicleRow = { id: string; registration: string };

export const buildVehicleAdminPagedListActions = buildRecordLifecyclePagedListActions<VehicleRow>;

export function canMutateVehicles(roleNames: string[]): boolean {
    const allowed = new Set([
        "System Administrator",
        "Administrator",
        "Office Staff",
        "Yard Staff",
    ]);
    return roleNames.some((r) => allowed.has(r));
}
